export default __webpack_public_path__ + "images/EG.d058ee7.png";